<form [formGroup]="form" class="flex w-4 ml-2">
  <button mat-icon-button [matMenuTriggerFor]="menu" i18n-matTooltip matTooltip="Filter">
    <mat-icon>filter_list</mat-icon>
  </button>
  <mat-menu #menu="matMenu" class="filter-popup-box">
    <div class="filter-body min-w-[380px]">
      <header class="filter-header">
        <button mat-icon-button class="button-close" (click)="(menu.close)">
          <mat-icon>close</mat-icon>
        </button>
      </header>
      <div class="filter-main">
        <div class="w-full" *ngFor="let filterObj of filterObjects">
          <label class="field-label">{{ filterObj.label }}</label>
          <sp-mat-select-search
            *ngIf="filterObj.input_type === 'dropdown'"
            class="w-full"
            [formControlName]="filterObj.name"
            [dataSource]="filterObj.options"
            [placeholder]="filterObj.placeholder"
            [config]="{ search: true, multiple: filterObj.multiple, enableSecondPartLabel: true }"
            [attrDataTestId]="'filter-menu_' + filterObj.name"
            (selectedChange)="filterObj.onSelectionChange && filterObj.onSelectionChange($event)"
            (removeChip)="removeChip($event)"
          ></sp-mat-select-search>
        </div>
      </div>
      <div class="filter-footer">
        <button mat-flat-button class="button-primary" (click)="onReset($event)" i18n>Reset</button>
        <button mat-flat-button class="button-primary" (click)="apply()" i18n>Apply</button>
      </div>
    </div>
  </mat-menu>
</form>
